import { Component } from '@angular/core';

@Component({
    selector: 'sidebar-page',
    templateUrl: 'sidebar-page.component.html',
    styleUrls: ['sidebar-page.component.less']
})
export class SidebarPageComponent {}
